var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8297 11.2899L10.5897 7.04995C10.4967 6.95622 10.3861 6.88183 10.2643 6.83106C10.1424 6.78029 10.0117 6.75415 9.8797 6.75415C9.74769 6.75415 9.61698 6.78029 9.49512 6.83106C9.37326 6.88183 9.26266 6.95622 9.1697 7.04995C8.98345 7.23731 8.87891 7.49076 8.87891 7.75495C8.87891 8.01913 8.98345 8.27259 9.1697 8.45995L12.7097 11.9999L9.1697 15.5399C8.98345 15.7273 8.87891 15.9808 8.87891 16.2449C8.87891 16.5091 8.98345 16.7626 9.1697 16.9499C9.26314 17.0426 9.37395 17.116 9.49579 17.1657C9.61763 17.2155 9.74809 17.2407 9.8797 17.2399C10.0113 17.2407 10.1418 17.2155 10.2636 17.1657C10.3854 17.116 10.4963 17.0426 10.5897 16.9499L14.8297 12.7099C14.9234 12.617 14.9978 12.5064 15.0486 12.3845C15.0994 12.2627 15.1255 12.132 15.1255 11.9999C15.1255 11.8679 15.0994 11.7372 15.0486 11.6154C14.9978 11.4935 14.9234 11.3829 14.8297 11.2899Z",
    fill: "#776F6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/Right_arrow.a0ee5eb43f594eeefee4d92f962bc3ae.svg";
export { ForwardRef as ReactComponent };